import { MemberChallenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { IUserPaidPlan } from '@wix/challenges-web-library';
import { isUserJoinedAlready } from '../../../../contexts/User/helpers/userTypeHandlers';
import { getPricingViewOptions } from '../../../../services/getPricingViewOptions';

export const isChallengePaidWithoutParticipation = (
  challenge: MemberChallenge,
  paidPlans: IUserPaidPlan[],
): boolean => {
  if (isUserJoinedAlready(challenge.summary?.participation?.state as any)) {
    return false;
  }

  const { isHasPaidPlans, isHasSinglePayment } = getPricingViewOptions(
    challenge.challenge,
    paidPlans,
  );

  return !!isHasPaidPlans || !!isHasSinglePayment;
};
